import { render, staticRenderFns } from "./lead-center-additional-settings.vue?vue&type=template&id=65b99d1f&"
import script from "./lead-center-additional-settings.vue?vue&type=script&lang=js&"
export * from "./lead-center-additional-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports